module.exports = __webpack_public_path__ + "static/media/Artboard2.4afaccf2.png";